import { IModel, IViolation } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { DataFlowColumn } from 'app/model/dataset/dataflowcolumn';
import { ExpressionBasedColumnBase } from './expression-based.column.base';

import { DataFlowExpression } from './dataflowexpression';
import { ModelMarkerWrapper } from 'app/shared/utils/model-marker-wrapper';
import { Owned } from 'app/model/base/named';
import { IExpressionBasedEntity } from './IExpressionBasedEntity';
import { format } from 'shell-models-lib';
import { IDataFlowDataType } from './dataflow-datatype';

@Metamodel.model({
    name: 'expressionBasedColumn'
})
export class ExpressionBasedColumn extends ExpressionBasedColumnBase implements IExpressionBasedEntity {
    public static readonly MODEL: IModel;

    @Metamodel.attribute({
        display: stringResources.Column,
        constraint: {
            required: true,
            validator: ExpressionBasedColumn.validateColumn
        }
    })
    public column: DataFlowColumn;

    public get entityName(): string {
        return this.column.name;
    }

    public set entityName(name: string) {
        this.column.name = name;
    }

    public get expressionReturnType(): IDataFlowDataType {
        return this.fixedReturnTypeExpression.expression ? this.fixedReturnTypeExpression.returnType : this.dataFlowExpression.returnType;
    }

    @Metamodel.attribute({
        display: stringResources.Expression,
        constraint: {
            required: true,
            validator: ExpressionBasedColumn.expressionIsNotEmptyValidator
        }
    })
    public dataFlowExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    @Metamodel.attribute({
        display: 'namepattern',
        constraint: {
            required: false
        }
    })
    public columnNameExpression: DataFlowExpression;

    public nameOptional?: boolean;

    public fixedReturnTypeExpression: DataFlowExpression = Owned.create<DataFlowExpression>(DataFlowExpression.MODEL, this);

    protected static expressionIsNotEmptyValidator(mapColumn: ExpressionBasedColumn, expression: DataFlowExpression): IViolation[] | undefined {
        if (mapColumn && mapColumn.column && !expression.expression) {
            return [{
                context: mapColumn,
                message: () => format(stringResources.DataFlowRequiresAnExpressionError, mapColumn.column.isTransient ? stringResources.LocalVariable : stringResources.Column)
            }];
        }
        return undefined;
    }

    private static validateColumn(columnPattern: ExpressionBasedColumn, column: DataFlowColumn): IViolation[] | undefined {
        if (column && !column.name && !columnPattern.nameOptional) {
            return [{
                context: columnPattern,
                message: () => format(stringResources.DataFlowColumnNameRequiredError, column.isTransient ? stringResources.LocalVariable : stringResources.Column)
            }];
        }
        return undefined;
    }

    public markDelete(modelMarkerWrapper: ModelMarkerWrapper): void {
        modelMarkerWrapper.markDelete(this.column);
    }
}
